import {useTranslation} from '@aboutyou/i18n';
import React from 'react';
import styled from 'styled-components';
import {COLORS} from '../../../../../constants/colors';
import {Icon} from '../../../../atoms/Icon/Icon';
import {GenericIconName} from '../../../../atoms/Icon/IconName';
import {Text} from '../../../../atoms/Text/Text';

/**
 * @deprecated This component is deprecated because it violates best practices defined in the @aboutyou/ui-components.
 * Do not take inspiration from this component for new implementations.
 */
export const DeliverySectionInfoText = () => {
  const {t} = useTranslation();

  return (
    <Root data-testid="deliveryInfoText">
      <Icon
        size={'S'}
        asset={GenericIconName.Warning}
        style={{fill: `${COLORS.Grey1}`}}
      />
      <Text transform="uppercase" size="px10" weight="w500" color="Grey1">
        {t('Products are not reserved')}
      </Text>
    </Root>
  );
};

const Root = styled.div`
  padding: 0.4375rem 1.5rem 0.4375rem 1.5rem;
  color: ${COLORS.Grey1};
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
  gap: 0.375rem;
  align-content: flex-start;
  border-bottom: 1px solid ${COLORS.Grey3};
  border-top: 1px solid ${COLORS.Grey3};
`;
